// extracted by mini-css-extract-plugin
export default {"calenderEventsMainSection":"meetingOverviewSection_calenderEventsMainSection__wdDat"};